import { Link, useLocation } from "react-router-dom";
import { Logo } from "./Logo";

export default function SiteFooter() {
  const { search } = useLocation();
  if (new URLSearchParams(search).get("print") === "1") return null;
  return (
    <footer className="border-t border-[#1A1915]/15 mt-24 relative z-10 bg-[#FAFAF9]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 py-16 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <Logo variant="horizontal" className="h-9 w-auto" />
          <p className="mt-4 text-sm text-[#78716C] max-w-xs leading-relaxed">
            A diagnostic instrument for personal authority. Not coaching. Not advice. A verdict.
          </p>
        </div>
        <div>
          <div className="eyebrow mb-4">Product</div>
          <ul className="space-y-2 text-sm text-[#1A1915]">
            <li><Link to="/model" className="hover:underline">Model</Link></li>
            <li><Link to="/lessons" className="hover:underline">Lessons</Link></li>
            <li><Link to="/theory" className="hover:underline">Theory</Link></li>
            <li><Link to="/checkout" className="hover:underline">Take diagnostic</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4">Legal</div>
          <ul className="space-y-2 text-sm text-[#1A1915]">
            <li><Link to="/terms" className="hover:underline">Terms</Link></li>
            <li><Link to="/privacy" className="hover:underline">Privacy</Link></li>
            <li><Link to="/refund" className="hover:underline">Refund policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#1A1915]/15">
        <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center justify-between text-xs text-[#78716C]">
          <div>© {new Date().getFullYear()} AuthorityOS. All rights reserved.</div>
          <div className="eyebrow">Diagnosis, not coaching.</div>
        </div>
      </div>
    </footer>
  );
}
